import React, { Component } from "react";
import axios from "axios";
import Paper from "@material-ui/core/Paper";
import urlBase from "../../../url-base";
import { Colors, Styles, tableStyles } from "../../../styles/theme";
import Dialog from "material-ui/Dialog";
import Grid from "@material-ui/core/Grid";
import {RadioButton, RadioButtonGroup} from "material-ui/RadioButton";
import InputMask from "react-input-mask";
import { Col, FormGroup, Label, Input, Alert} from "reactstrap";
import CurrencyFormat from "react-currency-format";
// IMPORTAÇÕES PARA O MATERIAL-UI (Ajustado para não misturar versões problemáticas)
import MuiThemeProvider from "material-ui/styles/MuiThemeProvider";
import CircularProgress from "material-ui/CircularProgress";
import Toggle from "material-ui/Toggle";
import Divider from "material-ui/Divider";

class Averbacao extends Component {
  constructor(props) {
    super(props);
    this.state = {
      financeData: [], // Inicializado como array vazio já que a API traz uma lista de Sales
      loading: true,
      error: null,
      modalOpen: false,
      detailsData: "loading",
      listaPendencias: [],
      listaCancelados: [],
      modalPendenciaOpen: false,
      buscaPendencia: '',
      pendenciaSelecionada: null, // <-- Agora guarda apenas uma única String
      observation: "",
      dataPrimeiroPagamento: "",
      showModalEfetivar: false,
      showModalCancelamento: false,
      isEnviando: false,
      erroValidacao: '',
      razaoSocial: '',
      selectedCancellationId: ''
    };
    this.styles = {
      table:{
        tableConfig:{
          ontFamily: "RubikRegular",
          textTransform: "uppercase",
        },
        theadTr:{
          fontFamily: "Sora",
          textTransform: "uppercase",
        }
      },
      iconTop:{
        paddingTop:5,
        marginRight: 0        
      },      
      error: {
        textAlign: "center",
        fontSize: 18,
        color:"#a8243e",
        background:"#fff",
        padding:10,
        borderRadius: 3,
        fontWeight: 500
      },
      zero: {
        textAlign: "center",
        fontSize: 18,
        background:"#fff",
        padding:10,
        borderRadius: 3,
        fontWeight: 500
      },
      modal: {
        width: "85%",
        maxWidth: "none",
      },
      fieldset: {
        border: "1px solid #f5aa00",
        padding: 10,
        marginTop: 15,
        paddingBottom: 25,
        borderRadius: 5
      },
      legend: {
        width: "auto",
        fontSize: 20,
        position: "relative",
        marginLeft: 15,
        padding: "0 5px"
      },
      input: {
        width: "100%"
      },
      label: {
        margin: 5,
        color: "#545454"
      },
      labelDestaque: {
        margin: 5,
        color: "#a8243e",   // azul mais chamativo
        fontSize: 18,       // maior que o padrão
        fontWeight: "bold"  // destaque no título
      },   
      col: {
        marginTop: 0,
        paddingBottom: 0
      },
      doc: {
        width: 150,
        height: 100,
        padding: ".25rem",
        backgroundColor: "#fff",
        border: "1px solid #dee2e6",
        borderRadius: ".25rem",
        cursor: "pointer"
      },
      docPdf: {
        width: 150,
        height: 100,
        padding: ".25rem",
        backgroundColor: "#fff",
        cursor: "pointer",
        marginTop: 5
      },
      titleDoc: {
        margin: 0
      },
      closeBtn: {
        float: "right",
        width: 25,
        cursor: "pointer",
        position: "relative",
        bottom: 15,
        left: 5
      },
      penEdit: {
        cursor: "pointer",
        padding: 10
      },
      backdrop: {
        position: 'fixed',
        top: 0, left: 0, right: 0, bottom: 0,
        backgroundColor: 'rgba(0, 0, 0, 0.5)',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        zIndex: 9999
      },
      modalBox: {
        backgroundColor: '#fff',
        padding: '20px',
        borderRadius: '5px',
        width: '400px',
        boxShadow: '0 4px 8px rgba(0,0,0,0.2)'
      },
      progressContainer: {
        marginTop: '15px',
        marginBottom: '15px',
        textAlign: 'center'
      },
      progressBarAnimated: {
        height: '4px',
        width: '100%',
        backgroundColor: '#007bff',
        borderRadius: '2px',
        animation: 'indeterminate 1.5s infinite linear', // Se quiser animar via CSS
        marginBottom: '5px'
      }      
    }; 
    this.parentageList = {
      "CÔNJUGE": 3,
      "FILHO": 4,
      "PAI/MÃE": 8,
      "OUTRO": 10
    };       
    this.formatarData = this.formatarData.bind(this);
    this.details = this.details.bind(this);
    this.selecionarPendencia = this.selecionarPendencia.bind(this); 
    this.confirmarCancelamento = this.confirmarCancelamento.bind(this);
    this.abrirModal = this.abrirModal.bind(this);
    this.fecharModal = this.fecharModal.bind(this);
    this.abrirModalCancelamento = this.abrirModalCancelamento.bind(this);
    this.fecharModalCancelamento = this.fecharModalCancelamento.bind(this);    
    this.handleDataChange = this.handleDataChange.bind(this);
    this.confirmarEfetivacao = this.confirmarEfetivacao.bind(this);
    this.buscarDados = this.buscarDados.bind(this);
    this.obterRazaoSocial = this.obterRazaoSocial.bind(this);
    }
  componentDidMount() {
    this.buscarDados();
    this.abrirPendencias();
    this.buscarCancelamentos();

  }  
  buscarCancelamentos() {
    axios
      .get(urlBase.loopBack + 'Cancellations')
      .then((response) => {
        console.log('Cancelamentos carregados:', response.data);

        this.setState({
          listaCancelados: response.data || []
        });
      })
      .catch((error) => {
        console.error('Erro ao buscar cancelamentos:', error);

        alert('Não conseguimos carregar a lista de cancelamentos.');

        this.setState({
          listaCancelados: []
        });
      });
}
  abrirModal() {
    this.setState({ showModalEfetivar: true, dataPrimeiroPagamento: '', erroValidacao: '' });
  }

fecharModal() {
  // Impede fechar a janela se estiver no meio do envio
  if (this.state.isEnviando) return; 
  this.setState({ showModalEfetivar: false });
}
abrirModalCancelamento() {
  this.setState({ showModalCancelamento: true });
}
fecharModalCancelamento() {
  // Impede fechar a janela se estiver no meio do envio
  if (this.state.isEnviando) return; 
  this.setState({ showModalCancelamento: false });
}
handleDataChange(e) {
  let value = e.target.value;
  // Máscara simples para MM/AAAA (apenas números e insere a barra)
  value = value.replace(/\D/g, "");
  if (value.length > 2) {
    value = value.substring(0, 2) + '/' + value.substring(2, 6);
  }
  this.setState({ dataPrimeiroPagamento: value, erroValidacao: '' });
}

obterRazaoSocial(codigo) {
  const url = `${urlBase.loopBack}APIS4s/BuscarEmpresa`;
  
  // Usamos URLSearchParams para enviar como application/x-www-form-urlencoded
  const params = new URLSearchParams();
  params.append('codigo', codigo);

  return axios.post(url, params)
    .then(function(resposta) {
      const dados = resposta.data;
      console.log("Dados recebidos:", dados);

      if (dados && dados.length > 0) {
        let razao = dados[0].RazaoSocial;
        console.log(razao);
        return dados[0].RazaoSocial;
      }
      return "Empresa não encontrada";
    })
    .catch(function(erro) {
      console.error("Erro ao buscar a razão social:", erro);
      throw erro;
    });
}
confirmarCancelamento() {

  const cancelId = this.state.selectedCancellationId;

  if (!cancelId) {
    alert('Escolha um motivo de cancelamento.');
    return;
  }

  const salesId = this.state.detailsData.sales.id;

  const dataPost = {
    status: "CANCELADO",
    cancellationId: cancelId,
    analyzing: false
  };

  const url =
    `${urlBase.loopBack}Sales/upsertWithWhere?where={"id":"${salesId}"}`;

  axios.post(url, dataPost)
    .then(() => {

      this.setState({isEnviando: false, showModalCancelamento: false });

      alert('Proposta cancelada com sucesso.');
      this.handleModalClose();
      this.buscarDados(); // seu método atual
    })
    .catch((error) => {

      console.error(error);

      this.setState({
        modalCancellationsLoading: false,
        modalCancellationsActions: false
      });

      alert('Erro ao cancelar a proposta.');
    });
}

confirmarEfetivacao() {
  let self = this;
  let dataModal = this.state.dataPrimeiroPagamento; // "MM/AAAA" capturado da janela

  // 1. Gera o objeto pronto usando o método de mapeamento
  let payload = this.prepararDadosEfetivacao(dataModal);
  if (payload === false) {
    self.setState({ isEnviando: false, showModalEfetivar: false });
    return;
  }

  // 2. Ativa o loading/barra de progresso
  this.setState({ isEnviando: true });

  // 3. Envia para a API externa de Efetivação
  let url = urlBase.loopBack + 'APIS4s/NovoUsuario';


  axios.post(url, payload)
    .then(function(resposta) {

      // CORREÇÃO: Verifica se a API do S4 retornou sucesso (codigo == 1)
      if (resposta.data && resposta.data.codigo === 1) {
        
        let financialManager = self.state.detailsData.financialManager || {};
        let sales = self.state.detailsData.sales || {};

        // --- DISPARO DO WHATSAPP ---
        if (financialManager.cellPhone) {
          let sendMsgZap = {
            numero: financialManager.cellPhone.replace(/\D/g, ''),
            nome: financialManager.firstName
          };

          axios.post(urlBase.loopBack + 'Sales/enviarWhatsapp', sendMsgZap)
            .then(function (response) {
              console.log("Whats enviado:", response);
            })
            .catch(function (error) {
              console.error("Erro Whatsapp:", error);
            });
        }

        // --- DISPARO DO EMAIL DE ATIVAÇÃO ---
        let sendEmailActive = {
          id: sales.id
        };

        axios.post(urlBase.loopBack + 'Sales/SendEmailActive', sendEmailActive)
          .then(function (response) {
            if (response.data && response.data.email == null) {
              let dentalY = localStorage.getItem('dental_y');
              if (dentalY === 'SALESMAN' && sales.tipoVenda === 'VENDEDOR') {
                alert('Atenção: Informar a Dental Center que o cliente não tem e-mail cadastrado para enviar.');
              } else {
                alert('Salvo no S4, mas e-mail do cliente não cadastrado para enviar e-mail.');
              }
            }
          })
          .catch(function (error) {
            console.error("Erro Email:", error);
          });
        // Sucesso Geral: Fecha a janela e desativa o loading
        self.setState({ isEnviando: false, showModalEfetivar: false });
        alert("Proposta efetivada com sucesso!");
        self.buscarDados();
        this.setState({modalOpen: false});        

      } else {
        // CORREÇÃO: Corrigido de 'response' para 'resposta'
        let msgErro = resposta.data ? resposta.data.mensagem : "Erro desconhecido";
        let codErro = resposta.data ? resposta.data.codigo : "Sem código";
        
        alert("Não foi possível enviar a proposta. Favor informar a Dental Center a mensagem: [Código: " + codErro + "] : " + msgErro);
        self.setState({ isEnviando: false });
      }      
    })
    .catch(function(error) {
      // Erro na requisição principal (Ex: queda de conexão, 500 na API)
      console.error(error);
      self.setState({ isEnviando: false });
      alert("Erro ao efetivar proposta no S4.");
    });   

  }

formatarParaAnoMes(dataModal) {
      const regex = /^(0[1-9]|1[0-2])\/(\d{4})$/;

      const match = dataModal.match(regex);

      if (!match) {
          alert("Informe uma data válida no formato MM/AAAA.")
          return false;
      }

    const mes = parseInt(match[1], 10);

    const ano = parseInt(match[2], 10);

    const hoje = new Date();

    const mesAtual = hoje.getMonth() + 1;

    const anoAtual = hoje.getFullYear();

    // Não permite meses anteriores ao atual

    if ( ano < anoAtual || (ano === anoAtual && mes < mesAtual) ) {
        alert("A data não pode ser anterior ao mês atual.");
        return false
    }

return `${ano}${mes.toString().padStart(2, '0')}`;


}
  
  handleModalClose() {
    this.setState({modalOpen: false});
  }

  /**
   * Buscar as informações dos planos exclusivos para servidores públicos
   */
  buscarDados() {
    // Buscando diretamente de Sales com o filtro correto do LoopBack
    const filtroAverbacao = {
        where: { planServer: true, 
                fMConfirm: { neq: null }
        },
        include: {
        relation: "financialManager",
        scope: {
           include: ["plans", "dependents"]
            
        }
        }
    };

    axios.get(`${urlBase.loopBack}Sales?filter=${JSON.stringify(filtroAverbacao)}`)
    .then(response => {
      this.setState(
        {
          financeData: response.data,
          loading: false
        },
        () => {
          $("#table_id").DataTable({
            destroy: true
          });
        }
      );    
      /*
      this.setState({
        financeData: response.data, 
        loading: false
      });
        $(document).ready( function () {
            $("#table_id").DataTable({
            destroy: true,  
            "language": {
                "url": urlBase.client + "assets/plugins/datatables/Portuguese-Brasil.lang"
            },
            "order": [[0, "desc"]],
            lengthMenu: [
                [10, 25, 50, 100, -1],
                ["10", "25", "50", 100, "Todas"]
            ],
            columnDefs: [
                {className: "mdl-data-table__cell--non-numeric"},
                { type: "date-uk", targets: 0 },
            ]
            });
        });   
        */   
    })
    .catch(err => {
      // eslint-disable-next-line no-console
      console.error("Erro ao buscar dados do LoopBack:", err);
      this.setState({
        error: 'Não foi possível carregar os dados.',
        loading: false
      });
    });
  }
  /**
   * Busca as informações da proposta para exibição
   * @param {*} salesId 
   */
  details(salesId) {
    // 1. Evita o erro de estrutura circular se passarem o evento do clique por engano
    if (salesId && typeof salesId === 'object' && salesId.target) {
      // eslint-disable-next-line no-console
      console.error("Aviso: O clique do botão passou o evento em vez do ID. Tratando...");
      return; 
    }

    let url = urlBase.loopBack + 'Sales/getProposalDetails';
    
    // Guardamos a referência da classe React
    let self = this;
    
    axios.post(url, { salesId: salesId })
      .then(function (response) {
        let resData = response.data || [];
        let detailsData = resData.length === 0 ? 'zero' : resData;

        if (detailsData !== 'zero') {
              self.obterRazaoSocial(detailsData.financialManager.contractNumberS4)
              .then(razao => {
                self.setState({ razaoSocial: razao });
              })
              .catch(erro => console.error(erro));  

          self.buscarEndereco(detailsData)
            .then(function (dadosProntos) {
              self.setState({
                detailsData: dadosProntos,
                modalOpen: true
              });
            })
            .catch(function (error) {
              console.error("Erro ao processar o endereço:", error);
              // Mesmo se falhar o endereço, abre o modal com o que tem
              self.setState({
                detailsData: detailsData,
                modalOpen: true
              });
            });
        } else {
          self.setState({
            detailsData: [],
            modalOpen: true
          });
        }
      })
      .catch(function (error) {
        // eslint-disable-next-line no-console
        console.error("Erro na requisição:", error);
        self.setState({ data: 'error' });
      });
  }
  /**
   * Busca as descrições do endereço do RF para exibição
   * @param {*} dadosOriginais 
   * @returns 
   */
  buscarEndereco(dadosOriginais) {
    // Garante que o objeto interno exista para evitar erros de 'undefined' ao ler propriedades
    let financialManager = dadosOriginais.financialManager || {};

    let urlUfs = urlBase.loopBack + 'APIS4s/UFs';
    let urlMunicipios = urlBase.loopBack + 'APIS4s/Municipios?idUF=' + (financialManager.state || '');
    let urlBairros = urlBase.loopBack + 'APIS4s/Bairros?idCity=' + (financialManager.city || '');
    let urlTipoLogradouro = urlBase.loopBack + 'APIS4s/tipoLogradouro';

    // Executa as 4 requisições em paralelo usando Promise.all
    return axios.all([
      axios.get(urlUfs, {}),
      axios.post(urlMunicipios, {}),
      axios.post(urlBairros, {}),
      axios.get(urlTipoLogradouro, {})
    ])
    .then(function (respostas) {
      // respostas[0] -> UFs | respostas[1] -> Municípios | respostas[2] -> Bairros | respostas[3] -> TipoLogradouro
      let listaUFs = respostas[0].data || [];
      let ufEncontrada = listaUFs.find(function (uf) { return uf.Id === financialManager.state; });
      let nomeUf = ufEncontrada ? ufEncontrada.Sigla : "Não encontrado";

      let listaMunicipios = respostas[1].data || [];
      let municipioEncontrado = listaMunicipios.find(function (m) { return m.Id === financialManager.city; });
      let nomeCidade = municipioEncontrado ? municipioEncontrado.Nome : "Não encontrado";

      let listaBairros = respostas[2].data || [];
      if (listaBairros.length > 0 && Array.isArray(listaBairros[0])) {
        listaBairros = listaBairros[0]; // Desembrulha o array duplo interno [[{}]]
      }

      let bairroEncontrado = listaBairros.find(function (b) { return b.Id === financialManager.district; });
      let nomeBairro = bairroEncontrado ? bairroEncontrado.Nome : "Não encontrado";

      // Busca o Tipo de Logradouro usando o 'addressType'
      let listaTipos = respostas[3].data || [];
      let tipoEncontrado = listaTipos.find(function (t) { return t.Id === financialManager.addressType; });
      let nomeTipoLogradouro = tipoEncontrado ? tipoEncontrado.Nome : "Não encontrado";

      return Object.assign({}, dadosOriginais, {
        nomeUf: nomeUf,
        nomeCidade: nomeCidade,
        nomeBairro: nomeBairro,
        nomeTipoLogradouro: nomeTipoLogradouro
      });
    })
    .catch(function (error) {
      // eslint-disable-next-line no-console
      console.error("Erro detalhado da API de Endereço:", error.response || error);
      return Object.assign({}, dadosOriginais, {
        nomeUf: "Erro ao buscar",
        nomeCidade: "Erro ao buscar",
        nomeBairro: "Erro ao buscar"
      });
    });
  }
  /**
   * Registra a penência pelo financeiro
   * @returns 
   */
  salvarPendencias () {
    let pendencyId = this.state.pendenciaSelecionada;
    let detailsData = this.state.detailsData;
    let observation = this.state.observation
    if (!pendencyId) {
      alert("Por favor, selecione uma pendência antes de salvar.");
      return;
    }

    // Proteção para encontrar o ID da venda (salesId) independentemente da estrutura do retorno
    let salesId = null;
    if (detailsData) {
      if (detailsData.sales && detailsData.sales.id) {
        salesId = detailsData.sales.id;
      } else if (detailsData.salesId) {
        salesId = detailsData.salesId;
      } else if (detailsData.Id) {
        salesId = detailsData.Id;
      } else if (Array.isArray(detailsData) && detailsData[0] && detailsData[0].sales) {
        salesId = detailsData[0].sales.id;
      }
    }

    if (!salesId) {
      alert("Erro: Não foi possível identificar o ID da proposta atual para vincular a pendência.");
      console.error("Estrutura do detailsData atual:", detailsData);
      return;
    }

    let dataPost = {
      id: salesId,
      pendencyId: pendencyId,
      observation: observation
    };
    
    let url = urlBase.loopBack + 'Sales/SendEmailPendency';

    // Exibe um aviso visual rápido que a requisição iniciou
    //console.log("Enviando pendência...", dataPost);

axios.post(url, dataPost)
  .then((response) => { // <-- Mudado para Arrow Function
    console.log(response);
    alert("Pendência registrada com sucesso! O vendedor será notificado via e-mail.");
    
    // Agora você pode usar o 'this' diretamente em ambos!
    this.setState({
      modalPendenciaOpen: false,
      modalOpen: false, 
      pendenciaSelecionada: '',
      buscaPendencia: '',
      observation:''
    });
    this.buscarDados(); // <-- Agora o 'this' vai funcionar perfeitamente aqui
  })
  .catch((error) => { // <-- Também recomendado mudar no catch
    console.error("Erro ao enviar e-mail de pendência:", error);
    alert("Erro ao processar o envio da pendência. ");
  });
  }
  /**
   * Converte da data para o formato DD/MM/AAAA
   * @param {*} dataString 
   * @returns 
   */
  formatarData (dataString)  {
        if (!dataString) return '-';
        // Pega apenas os primeiros 10 caracteres: "2026-06-24"
        const [ano, mes, dia] = dataString.substring(0, 10).split('-');
        return `${dia}/${mes}/${ano}`;
  }

  /**
   * Busca a lista de pendências
   */
  abrirPendencias () {
    let self = this;
    let url = urlBase.loopBack + 'Pendencies';

    axios.get(url)
      .then(function(response) {
        self.setState({
          listaPendencias: response.data || []
        });
      })
      .catch(function(error) {
        console.error("Erro ao buscar pendências:", error);
        alert("Não foi possível carregar a lista de pendências.");
      });
  }

  handleBtnRegistrarPendencia() {
    this.setState({
      modalPendenciaOpen: true
    });
  }
  handleObservationChange(event) {
    this.setState({
      observation: event.target.value
    });
  }
  /**
   * Carrega os documentos anexos 
   * @param {*} typeDoc 
   */
fileToBase64(typeDoc) {
    let reader = new FileReader();
    let file = document.getElementById('doc_'+typeDoc).files[0];

    // CORRIGIDO: Mudado para Arrow Function para herdar o 'this' do componente React
    reader.onloadend = () => {
      let dataSubmit = {
        id: this.state.detailsData.financialManager.id,
        imagesDocId: this.state.detailsData.imagesDoc.id,
        imagesDocs: {
          cpf: '', rg: '', rg2: '', address: '', credtFrontal: '',
          physicalContract: '', adtive: '', others: '', declarationPortability: '',
        }
      };

      dataSubmit.imagesDocs[typeDoc] = reader.result;

      axios.post(urlBase.loopBack + 'ImagesDocs/saveDocsFinancialManager', dataSubmit)
      .then((response) => {
        let state = this.state;
        state.detailsData.imagesDoc = response.data.images;
        this.setState(state);
      })
      .catch(() => {
        alert('Erro ao salvar imagem do '+typeDoc);
      });
    };
    
    reader.readAsDataURL(file);
  }

  openWindow(image, title) {
    let url = urlBase.client + 'spinimage?im=' + image;

    window.open(
      url,
      title,
      "location,status,scrollbars,resizable,width=800, height=800"
    );
  } 

prepararDadosEfetivacao(dataPrimeiroPagamento) {
  let detailsData = this.state.detailsData;
  let funcionarioCadastro = localStorage.getItem('dental_codeS4');

  // Garante que os objetos internos existam para evitar quebras por 'undefined'
  let financialManager = detailsData.financialManager || {};
  let salesman = detailsData.salesman || {};
  let holder = detailsData.holder || {};
  let dependents = detailsData.dependents || [];
  const currentDate = new Date().toISOString().split('T')[0];
  // 1. Estrutura Base do Objeto
  let dataPost = {
    "dataForS4": {
      "parceiro": {
        "codigo": salesman.codeS4,
        "tipoCobranca": 1
      },
      "responsavelFinanceiro": {
        "dataAssinaturaContrato": financialManager.dateSignatureContractS4,
        "codigoContrato": financialManager.contractNumberS4,
        "nome": financialManager.firstName,
        "dataNascimento": financialManager.dateOfBirth,
        "cpf": (financialManager.cpf || '').replace(/\D/g, ''),
        "identidadeNumero": (financialManager.rg || '').replace(/\D/g, ''),
        "identidadeOrgaoExpeditor": financialManager.rgEmitter,
        "sexo": financialManager.gender,
        "matricula": financialManager.matServidor,
        "dataApresentacao" : currentDate,
        "endereco": {
          "cep": (financialManager.cep || '').replace(/\D/g, ''),
          "tipoLogradouro": financialManager.addressType,
          "logradouro": financialManager.address,
          "numero": financialManager.addressNumber,
          "complemento": financialManager.addressComplement,
          "bairro": financialManager.district,
          "municipio": financialManager.city,
          "uf": financialManager.state
        },
        "contatoResponsavelFinanceiro": []
      },
      "dependente": [],
      "incluirMensalidades": 0
    }
  };

  // 2. Adiciona Contatos Dinamicamente ao Responsável Financeiro
  if (financialManager.homePhone && financialManager.homePhone.replace(/\D/g, '').length > 0) {
    dataPost.dataForS4.responsavelFinanceiro.contatoResponsavelFinanceiro.push({
      "tipo": 1,
      "dado": financialManager.homePhone.replace(/\D/g, '')
    });
  }

  if (financialManager.cellPhone && financialManager.cellPhone.replace(/\D/g, '').length > 0) {
    dataPost.dataForS4.responsavelFinanceiro.contatoResponsavelFinanceiro.push({
      "tipo": 8,
      "dado": financialManager.cellPhone.replace(/\D/g, '')
    });
  }

  if (financialManager.cellPhone2 && financialManager.cellPhone2.replace(/\D/g, '').length > 0) {
    dataPost.dataForS4.responsavelFinanceiro.contatoResponsavelFinanceiro.push({
      "tipo": 8,
      "dado": financialManager.cellPhone2.replace(/\D/g, '')
    });
  }

  if (financialManager.email && financialManager.email.length > 0) {
    dataPost.dataForS4.responsavelFinanceiro.contatoResponsavelFinanceiro.push({
      "tipo": 50,
      "dado": financialManager.email
    });
  }
  let dataPagamento = this.formatarParaAnoMes( dataPrimeiroPagamento )

  if (dataPagamento === false ) {
    return false
  }
  let carencia = (financialManager.portability ? 0 : 1);
  // 3. Adiciona o Titular (Holder) à lista de dependentes do S4
  let planoValorHolder = holder.valuePlan ? holder.valuePlan.replace(',', '.') : '0.00';
  let objetoHolder = {
    "tipo": 1,
    "nome": holder.firstName,
    "dataNascimento": holder.dateOfBirth,
    "cpf": (holder.cpf || '').replace(/\D/g, ''),
    "sexo": holder.gender,
    "plano": holder.plans ? holder.plans.codeS4 : null,
    "planoValor": planoValorHolder,
    "nomeMae": holder.motherName,
    "carenciaAtendimento": carencia,
    "rcaId": holder.rcaId,
    "MMYYYY1Pagamento":  dataPagamento,
    "funcionarioCadastro": funcionarioCadastro,
    "cns": holder.susNumber
  };
  dataPost.dataForS4.dependente.push(objetoHolder);

  // 4. Adiciona os Dependentes reais da Proposta
  for (let i = 0; i < dependents.length; i++) {
    let dep = dependents[i];
    let planoValorDep = dep.valuePlan ? dep.valuePlan.replace(',', '.') : '0.00';
    let tipoParentesco = this.parentageList ? this.parentageList[dep.parentage] : 10; // 10 = OUTRO caso falte

    let objetoDependente = {
      "tipo": tipoParentesco,
      "nome": dep.firstName,
      "dataNascimento": dep.dateOfBirth,
      "cpf": (dep.cpf || '').replace(/\D/g, ''),
      "sexo": dep.gender,
      "plano": dep.plans ? dep.plans.codeS4 : null,
      "planoValor": planoValorDep,
      "nomeMae": dep.motherName,
      "carenciaAtendimento": dep.lackOfCare,
      "rcaId": dep.rcaId,
      "MMYYYY1Pagamento": dataPagamento, // Usa a data da modal
      "funcionarioCadastro": funcionarioCadastro,
      "cns": dep.susNumber
    };

    dataPost.dataForS4.dependente.push(objetoDependente);
    //dataPost.empresa = financialManager.codOrgao || ""
  }

  return dataPost;
}  
 
selecionarPendencia(id) {
  // Debug para ver se o clique está chegando aqui e qual ID está pegando
  console.log("Pendência clicada:", id);
  this.setState({ pendenciaSelecionada: id });
}  
  render() {
   
    const { financeData, loading, error } = this.state;
    const statusStyles = {
      'ATIVO': {
        bg: Colors.statusAtivoBg,
        color: Colors.statusAtivoText
      },
      'CANCELADO': {
        bg: Colors.statusCanceladoBg,
        color: Colors.statusCanceladoText
      },
      'PENDENTE': {
        bg: Colors.statusPendenteBg,
        color: Colors.statusPendenteText
      },
      'EM VALIDAÇÃO': {
        bg: Colors.statusValidacaoBg,
        color: Colors.statusValidacaoText
      },
      'PAGAMENTO PENDENTE': {
        bg: Colors.statusPagamentoPendenteBg,
        color: Colors.statusPagamentoPendenteText
      }
    };
    // 1. Tela de Carregamento
    if (loading) {
      return (
        <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: '80vh' }}>
          <CircularProgress />
        </div>
      );
    }

    // 2. Tela de Erro
    if (error) {
      return (
        <h3 style={{ color: 'red', textAlign: 'center' }}>
          {error}
        </h3>
      );
    }

    // 3. Renderização da Página com os Dados
    return (
      <MuiThemeProvider>
        <div style={{ padding: 20 }}>
                <style>{tableStyles}</style>
          <h2 style={{ fontFamily: 'Roboto, sans-serif' }}>
            Painel de Gestão Financeira
          </h2>

          {/* Substituído o Grid por uma estrutura flex padrão compatível com React 15 */}
          <div style={{ display: 'flex', flexDirection: 'column', gap: '20px', marginTop: 20 }}>
            <Paper style={{overflow: 'auto', boxShadow:"none", marginLeft: 10, marginTop: 20,borderRadius:0}}>
              <table id="table_id" className="table-striped" style={{ width: '100%', borderCollapse: 'collapse' }}>
              <thead>
                <tr style={this.styles.table.theadTr}>
                    <th style={{ width: 85, padding: 10 }}>Data</th>
                    <th>Resp. Financeiro</th>
                    <th>CPF</th>
                    <th>Plano</th>
                    <th>Serv. Púb</th>
                    <th>Vidas</th>
                    <th>Valor</th>
                    <th>Status</th>

                  </tr>
                </thead>
                <tbody>
                  {financeData && financeData.length > 0 ? (
                    financeData.map((item, index) => (
                      <tr
                        id={'row_sales_' + item.id}
                        key={index}
                        className="row_table"
                        onClick={this.details.bind(this,item.id)}
                        style={{ cursor: 'pointer' }}
                      >
                        <td style={{ padding: 10 }} data-label="Data" data-order={item.created}> {this.formatarData(item.created)}</td>
                        {/* Se o include do financialManager funcionou, ele estará dentro de item.financialManager */}
                        <td data-label="Resp. Financeiro">
                          {item.financialManager.firstName}
                        </td>
                        <td data-label="CPF">{item.financialManager.cpf}</td>
                        <td data-label="Plano">{item.financialManager.plans.name}</td>
                        <td data-label="Serv Púb.">{item.planServer ? "Sim" : "Não"}</td>
                        <td data-label="Vidas">{item.financialManager.dependents.length}</td>
                        <td data-label="Valor">{'R$ ' + item.financialManager.responsibility}</td>
                        <td data-label="Status">
                          <span
                            style={{
                              padding: '6px 14px',
                              borderRadius: '20px',
                              fontSize: '11px',
                              fontWeight: 'bold',
                              textTransform: 'uppercase',

                              backgroundColor:
                                statusStyles[item.status]
                                  ? statusStyles[item.status].bg
                                  : '#eee',

                              color:
                                statusStyles[item.status]
                                  ? statusStyles[item.status].color
                                  : '#555'
                            }}
                          >
                            {
                            item.status === "PAGAMENTO PENDENTE" ? (
                                item.fMConfirm === null  || item.fMConfirm === undefined ? (
                                 "AGUARDANDO CONFIRMAÇÃO"
                              ) : (
                                "AGUARDANDO AVERBAÇÃO"
                              )
                            ) : item.status === "EM VALIDAÇÃO" ? 
                                "PENDÊNCIA RESOLVIDA"                              
                              : item.status
                            }                            
                            {/* 
                            {
                            item.status === "PAGAMENTO PENDENTE" ?
                              item.fMConfirm === null  || item.fMConfirm === undefined ? (
                                "AGUARDANDO CONFIRMAÇÃO"
                              ) : (
                                item.planServer === true && item.financialConfirmation === false ?
                                "AGUARDANDO AVERBAÇÃO" :
                                item.status
                              ) : 
                               item.status === "EM VALIDAÇÃO" ? 
                               "PENDÊNCIA RESOLVIDA"
                              
                              : item.status
                            }    
*/}
                          </span>
                        </td>
                          
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td colSpan="7" style={{ padding: 10, textAlign: 'center' }}>Nenhuma venda encontrada.</td>
                    </tr>
                  )}
                </tbody>
              </table>
            </Paper>

          </div>
            <Dialog
              title={
                <div>
                  Resumo da Proposta -
                  <img
                    style={this.styles.closeBtn}
                    src={urlBase.client+'/assets/images/icons/icon_close.png'}
                    onClick={this.handleModalClose.bind(this)}
                    alt="Icone fechar"
                  />
                </div>
              }
              titleStyle={{textAlign:'center'}}
              bodyStyle={{padding: '0 10px 24px'}}
              actions={<span>&nbsp;</span>}
              modal={false}
              open={this.state.modalOpen}
              onRequestClose={this.handleModalClose.bind(this)}
              autoScrollBodyContent={true}
              contentStyle={this.styles.modal}
            >            
              <div>
                {
                  this.state.detailsData == 'loading' ? (
                <div style={{textAlign: 'center', marginTop: 30}}>
                  <CircularProgress />
                  <p>Carregando...</p>
                </div>
                  ) : (
                    this.state.detailsData == 'error' ? (
                <p style={this.styles.error}>
                  Erro ao buscar dados.
                </p>
                  ) : (
                      this.state.detailsData == 'zero' ? (
                <div style={this.styles.zero}>
                  <p>Proposta não encontrada.</p>
                </div>
                  ) : (
                <div style={{marginBottom: 25}}>
                  <fieldset id="fm_forma_confirmacao" style={this.styles.fieldset}>
                    <legend htmlFor="fm_forma_confirmacao" style={this.styles.legend}>
                      Dados da Empresa
                    </legend>  
                    <Grid container spacing={24}>
                          <Grid item style={this.styles.col} xs={12} sm={12} md={2} lg={2}>
                            <label style={this.styles.label} htmlFor="fm_codOrgao">Código do Órgão</label>
                            <Input style={this.styles.input} 
                              type="text" 
                              id="fm_codOrgao"
                              disabled={true}                     
                              defaultValue={this.state.detailsData.financialManager.contractNumberS4}
                          />
                          </Grid>
                          <Grid item style={this.styles.col} xs={12} sm={12} md={3} lg={3}>
                            <label style={this.styles.label} htmlFor="fm_nomeOrgao">Nome do Órgão</label>
                            <Input
                              id="fm_nomeOrgao"
                              style={this.styles.input}
                              type="text"
                              disabled={true}
                              defaultValue={this.state.razaoSocial}
                            />
                          </Grid>
                          <Grid item style={this.styles.col} xs={12} sm={12} md={3} lg={3}>
                            <label style={this.styles.label} htmlFor="fm_matServidor">Matrícula do Servidor</label>
                            <Input style={this.styles.input} id="fm_matServidor" type="text" disabled
                              defaultValue={this.state.detailsData.financialManager.matServidor}  />
                          </Grid>

                    </Grid>                    
                                      
                 
                  </fieldset>
                  <fieldset id="fm_forma_confirmacao" style={this.styles.fieldset}>                                
                    <legend htmlFor="fm_forma_confirmacao" style={this.styles.legend}>
                      Forma de Confirmação
                    </legend>

     
                    <Grid container spacing={24}>                
                      <Grid item style={this.styles.col} xs={12} sm={12} md={12} lg={12}>
                        <RadioButtonGroup 
                          name="confirmation"
                          id="fm_forma_confirmacao"
                          valueSelected={this.state.detailsData.sales.fMChanelConfirm}
                        >
                          <RadioButton
                            value="EMAIL"
                            label="Email"
                            aria-label="Email"                              
                            labelStyle={{color : "#000000" }}
                            disabled={true}
                          />
                        </RadioButtonGroup>
                      </Grid>
                    </Grid>
                  </fieldset>

                  <fieldset style={this.styles.fieldset}>
                    <legend htmlFor="fm_portabilidade" style={this.styles.legend}>
                      Portabilidade
                    </legend>

                    <Grid container spacing={24}>
                      <Grid item style={this.styles.col} xs={12} sm={12} md={12} lg={12}>
                        <RadioButtonGroup
                          id="fm_portabilidade"
                          name="confirmation"
                          valueSelected={this.state.detailsData.financialManager.portability}
                        >
                          <RadioButton
                            value={true}
                            label="Sim"
                            aria-label="Sim"                              
                            labelStyle={{color : "#000000" }}
                            disabled={true}
                          />
                          <RadioButton
                            value={false}
                            label="Não"
                            aria-label="Não"                              
                            labelStyle={{color : "#000000" }}
                            disabled={true}
                          />
                        </RadioButtonGroup>
                      </Grid>
                    </Grid>
                  </fieldset>

                  <fieldset style={this.styles.fieldset}>
                    
                    <legend style={this.styles.legend}>
                      Responsável Financeiro
                    </legend>

                    <Grid container spacing={24}>
                      
                      <Grid item style={this.styles.col} xs={12} sm={12} md={6} lg={6}>
                        <label style={this.styles.label} htmlFor="fm_firstName">Nome </label>
                        <Input
                          id="fm_firstName"
                          style={this.styles.input}
                          type="text"
                          disabled={true}
                          defaultValue={this.state.detailsData.financialManager.firstName + this.state.detailsData.financialManager.lastName}
                        />
                      </Grid>
                      <Grid item style={this.styles.col} xs={12} sm={12} md={5} lg={6}>
                        <label style={this.styles.label} htmlFor="fm_susNumber" >Cartão SUS</label>
                        <Input
                          id="fm_susNumber"
                          style={this.styles.input}
                          type="text"
                          disabled={true}
                          defaultValue={this.state.detailsData.financialManager.susNumber}
                        />
                      </Grid>
                  
                      <Grid item style={this.styles.col} xs={12} sm={12} md={4} lg={4}>
                        <label style={this.styles.label} htmlFor="fm_homePhone" >Telefone Resid.</label>
                        <InputMask
                          id="fm_homePhone"
                          style={this.styles.input}
                          className="form-control"
                          mask="(99) 9999-9999"
                          type="text"
                          disabled={true}
                          defaultValue={this.state.detailsData.financialManager.homePhone}

                        />
                      </Grid>
                      <Grid item style={this.styles.col} xs={12} sm={12} md={4} lg={4}>
                        <label style={this.styles.label} htmlFor="fm_cellPhone" >Celular 1</label>
                        <InputMask
                          id="fm_cellPhone"
                          style={this.styles.input}
                          mask="(99) \9 9999-9999"
                          className="form-control"
                          type="text"
                          disabled={true}
                          defaultValue={this.state.detailsData.financialManager.cellPhone}

                        />
                      </Grid>
                      <Grid item style={this.styles.col} xs={12} sm={12} md={4} lg={4}>
                        <label style={this.styles.label} htmlFor="fm_cellPhone2">Celular 2</label>
                        <InputMask
                          id="fm_cellPhone2"
                          style={this.styles.input}
                          mask="(99) \9 9999-9999"
                          className="form-control"
                          type="text"
                          disabled={true}
                          defaultValue={this.state.detailsData.financialManager.cellPhone2}
                        />
                      </Grid>
                      <Grid item style={this.styles.col} xs={12} sm={12} md={4} lg={4}>
                        <label style={this.styles.label} htmlFor="fm_email">Email</label>
                        <Input
                          id="fm_email"
                          style={this.styles.input}
                          type="text"
                          disabled={true}
                          defaultValue={this.state.detailsData.financialManager.email}
                        />
                      </Grid>
                      <Grid item style={this.styles.col} xs={12} sm={12} md={4} lg={4}>
                        <label style={this.styles.label} htmlFor="fm_motherName">Nome da Mãe</label>
                        <Input
                          id="fm_motherName"
                          style={this.styles.input}
                          type="text"
                          disabled={true}
                          defaultValue={this.state.detailsData.financialManager.motherName}
                        />
                      </Grid>
                      <Grid item style={this.styles.col} xs={12} sm={12} md={2} lg={2}>
                        <label style={this.styles.label} htmlFor="fm_rg">RG</label>
                        <Input
                          id="fm_rg"
                          style={this.styles.input}
                          type="text"
                          disabled={true}
                          defaultValue={this.state.detailsData.financialManager.rg}
                        />
                      </Grid>
                      <Grid item style={this.styles.col} xs={12} sm={12} md={2} lg={2}>
                        <label style={this.styles.label} htmlFor="fm_rgEmitter">Org. Expedidor</label>
                        <Input
                          id="fm_rgEmitter"
                          style={this.styles.input}
                          type="text"
                          disabled={true}
                          defaultValue={this.state.detailsData.financialManager.rgEmitter}
                        />
                      </Grid>
                      <Grid item style={this.styles.col} xs={12} sm={12} md={3} lg={3}>
                        <label style={this.styles.label} htmlFor="fm_cpf" >CPF</label>
                        <InputMask
                          id="fm_cpf"
                          style={this.styles.input}
                          mask="999.999.999-99"
                          className="form-control"
                          type="tel"
                          disabled={true}
                          defaultValue={this.state.detailsData.financialManager.cpf}
                        />
                        <Alert id="alert_fm_cpf">*Cpf inválido!</Alert>
                      </Grid>
                      <Grid item style={this.styles.col} xs={12} sm={12} md={3} lg={3}>
                        <label style={this.styles.label}  htmlFor="fm_dateOfBirth">Data de Nasc.</label>
                        <Input
                          id="fm_dateOfBirth"
                          style={this.styles.input}
                          type="date"
                          disabled={true}
                          defaultValue={this.state.detailsData.financialManager.dateOfBirth}

                        />
                      </Grid>
                      <Grid item style={this.styles.col} xs={12} sm={12} md={3} lg={3}>
                        <label style={this.styles.label} htmlFor="fm_maritalStatus">Estado Civil</label>
                        <Input
                          id="fm_maritalStatus"
                          type="select"
                          className="form-control"
                          defaultValue={this.state.detailsData.financialManager.maritalStatus}
                          disabled={true}
                        >
                          <option value="SOLTEIRO">SOLTEIRO</option>
                          <option value="CASADO">CASADO</option>
                          <option value="VIÚVO">VIÚVO</option>
                          <option value="SEPARADO">SEPARADO</option>
                          <option value="DIVORCIADO">DIVORCIADO</option>
                          <option value="RELAÇÃO ESTÁVEL">RELAÇÃO ESTÁVEL</option>
                        </Input>
                      </Grid>
                      <Grid item style={this.styles.col} xs={12} sm={12} md={3} lg={3}>
                        <label style={this.styles.label} htmlFor="fm_gender">Sexo</label>
                        <Input
                          id="fm_gender"
                          type="select"
                          className="form-control"
                          defaultValue={this.state.detailsData.financialManager.gender === 1 ? "MASCULINO" : "FEMININO"}
                          disabled={true}
                        >
                          <option value="0">Feminino</option>
                          <option value="1">Masculino</option>
                        </Input>
                      </Grid>
                      <Grid item style={this.styles.col} xs={12} sm={12} md={3} lg={2}>
                        <label style={this.styles.label} htmlFor="fm_cep">CEP
                          <i
                            id="loading_address"
                            style={{ display: "none", marginLeft: 10, width: 15 }}
                            className="fa fa-spinner fa-spin">
                            &nbsp;
                          </i>
                        </label>
                        <InputMask
                          id="fm_cep"
                          style={this.styles.input}
                          mask="99.999-999"
                          className="form-control"
                          type="text"
                          disabled={true}
                          defaultValue={this.state.detailsData.financialManager.cep}
                        />
                      </Grid>
                      <Grid item style={this.styles.col} xs={12} sm={12} md={2} lg={2}>
                        <label style={this.styles.label} htmlFor="fm_addressType">Tipo</label>
                        <Input
                          id="fm_addressType"
                          className="form-control"
                          defaultValue={this.state.detailsData.nomeTipoLogradouro}
                          disabled={true}
                        />

                      </Grid>
                      <Grid item style={this.styles.col} xs={12} sm={12} md={5} lg={7}>
                        <label style={this.styles.label} htmlFor="fm_address">Endereço</label>
                        <Input
                          id="fm_address"
                          style={this.styles.input}
                          type="text"
                          disabled={true}
                          defaultValue={this.state.detailsData.financialManager.address}
                        />
                      </Grid>
                      <Grid item style={this.styles.col} xs={12} sm={12} md={2} lg={1}>
                        <label style={this.styles.label} htmlFor="fm_addressNumber">Número</label>
                        <Input
                          id="fm_addressNumber"
                          style={this.styles.input}
                          type="text"
                          disabled={true}
                          defaultValue={this.state.detailsData.financialManager.addressNumber}
                        />
                      </Grid>
                      <Grid item style={this.styles.col} xs={12} sm={12} md={3} lg={3}>
                        <label style={this.styles.label} htmlFor="fm_addressComplement">Complemento</label>
                        <Input
                          id="fm_addressComplement"
                          style={this.styles.input}
                          type="text"
                          disabled={true}
                          defaultValue={this.state.detailsData.financialManager.addressComplement}

                        />
                      </Grid>
                      <Grid item style={this.styles.col} xs={12} sm={12} md={1} lg={1}>
                        <label style={this.styles.label} htmlFor="fm_state">Estado</label>
                        <Input
                          id="fm_state"
                          className="form-control"
                          defaultValue={this.state.detailsData.nomeUf}
                          disabled={true}
                        />

                      </Grid>
                      <Grid item style={this.styles.col} xs={12} sm={12} md={4} lg={4}>
                        <label style={this.styles.label} htmlFor="fm_city">Cidade</label>
                        <Input
                          id="fm_city"
                          className="form-control"
                          defaultValue={this.state.detailsData.nomeCidade}
                          disabled={true}

                        />

                      </Grid>
                      <Grid item style={this.styles.col} xs={12} sm={12} md={4} lg={4}>
                        <label style={this.styles.label} htmlFor="fm_bairro">Bairro</label>
                         <Input
                          id="fm_city"
                          className="form-control"
                          defaultValue={this.state.detailsData.nomeBairro}
                          disabled={true}

                        />
                      </Grid>
                                      
                      <Grid item style={this.styles.col} xs={12} sm={12} md={12} lg={12}>
                          <Grid container spacing={24} alignItems="center"> {/* Adicionado align-items="center" */}
                          <Grid item xs={8} sm={8} md={8} lg={10}>
                            <h4 style={this.styles.h4}>Documentos Anexados</h4>
                          </Grid>
                          {
                            this.state.disabledInput === false ? (
                              <Grid item xs={2} sm={2} md={2} lg={1}>
                                {/* Removido o div com margem para evitar o desalinhamento */}
                                <Toggle
                                  id="id_editar"
                                  labelPosition="right"
                                  style={{ float: "right", width: 0 }}
                                  onToggle={this.onToggle.bind(this)}
                                />
                              </Grid>
                            ) : (
                              null
                            )
                          }
                          <Grid item xs={2} sm={2} md={2} lg={1}>
                            <label style={this.styles.label} htmlFor="id_editar"></label>
                          </Grid>
{/* ################### Imagem Autorização de Averbação ################### */}
                          <Grid item xs={12} sm={6} md={4} lg={4} style={{textAlign: 'center'}}>
                            <div
                              style={{backgroundColor: this.state.colorBackImg, paddingBottom: 10}}
                            >

                              {
                                this.state.toggleChecked == true ? (
                                  <div>
                                    <label htmlFor="doc_autorizacaoAverbacao" style={{cursor:'pointer'}}>
                                      <i style={this.styles.penEdit} className="fas fa-pen">{''}</i> 
                                    </label>

                                    <input
                                      id="doc_rg"
                                      style={{visibility:"hidden",position:'absolute',left: -9999}}
                                      type="file"
                                      name="rg"
                                      onChange={this.fileToBase64.bind(this, 'autorizacaoAverbacao')}
                                    />
                                  </div>
                                ) : null
                              }

                              <p style={this.styles.titleDoc}>AUTORIZAÇÃO DE AVERBAÇÃO</p>
                              {/* todo */}
                              {  
                                  this.state.detailsData.imagesDoc.autorizacaoAverbacao != '' && 
                                  this.state.detailsData.imagesDoc.autorizacaoAverbacao != undefined ? (
                              <a
                                onClick={this.openWindow.bind(this, this.state.detailsData.imagesDoc.autorizacaoAverbacao, 'Imagem da Autorização de Averbação')}
                                target="_blank">
                                
                                {
                                    
                                  this.state.detailsData.imagesDoc.autorizacaoAverbacao.substr(this.state.detailsData.imagesDoc.autorizacaoAverbacao.length - 3, this.state.detailsData.imagesDoc.autorizacaoAverbacao.length).toLowerCase() == 'pdf' ? (
                                  <span>
                                    &nbsp;&nbsp;&nbsp;&nbsp;
                                    <i
                                      className="far fa-file-pdf fa-6x"
                                      style={{...this.styles.docPdf, backgroundColor: this.state.colorBackImg}}
                                    >&nbsp;</i>
                                  </span>
                                  ) : (
                                <img
                                  style={this.styles.doc}
                                  src={urlBase.loopBack + 'attachments/docs/download/' +  this.state.detailsData.imagesDoc.autorizacaoAverbacao}
                                  alt="Imagem da Autorização de Averbação"
                                />
                                  )
                                }
                              </a>
                                ) : (<div style={{marginTop: 25}}>Sem imagem <br/>cadastrada</div>)
                              }
                            </div>
                          </Grid>
{/* ################### Imagem CNH ################### */}
                          <Grid item xs={12} sm={6} md={4} lg={4} style={{textAlign: 'center'}}>
                            <div
                              style={{backgroundColor: this.state.colorBackImg, paddingBottom: 10}}
                            >

                              {
                                this.state.toggleChecked == true ? (
                                  <div>
                                    <label htmlFor="doc_rg" style={{cursor:"pointer"}}>
                                      <i style={this.styles.penEdit} className="fas fa-pen">{""}</i> 
                                    </label>

                                    <input
                                      id="doc_rg"
                                      style={{visibility:"hidden",position:"absolute",left: -9999}}
                                      type="file"
                                      name="cng"
                                    />
                                  </div>
                                ) : null
                              }

                              <p style={this.styles.titleDoc}>CNH</p>
                              {/* todo */}
                              {  
                                  this.state.detailsData.imagesDoc.cnh != "" ? (
                              <a
                                onClick={this.openWindow.bind(this, this.state.detailsData.imagesDoc.cng, "Imagem do CNH")}
                                target="_blank">
                                
                                {
                                    
                                  this.state.detailsData.imagesDoc.rg.substr(this.state.detailsData.imagesDoc.cnh.length - 3, this.state.detailsData.imagesDoc.cnh.length).toLowerCase() == "pdf" ? (
                                  <span>
                                    &nbsp;&nbsp;&nbsp;&nbsp;
                                    <i
                                      className="far fa-file-pdf fa-6x"
                                      style={{...this.styles.docPdf, backgroundColor: this.state.colorBackImg}}
                                    >&nbsp;</i>
                                  </span>
                                  ) : (
                                <img
                                  style={this.styles.doc}
                                  src={urlBase.loopBack + "attachments/docs/download/" + this.state.detailsData.imagesDoc.cnh}
                                  alt="Imagem do CNH"
                                />
                                  )
                                }
                              </a>
                                ) : (<div style={{marginTop: 25}}>Sem imagem <br/>cadastrada</div>)
                              }
                            </div>
                          </Grid>
{/* ################### Imagem RG ################### */}
                          <Grid item xs={12} sm={6} md={4} lg={4} style={{textAlign: 'center'}}>
                            <div
                              style={{backgroundColor: this.state.colorBackImg, paddingBottom: 10}}
                            >

                              {
                                this.state.toggleChecked == true ? (
                                  <div>
                                    <label htmlFor="doc_rg" style={{cursor:"pointer"}}>
                                      <i style={this.styles.penEdit} className="fas fa-pen">{""}</i> 
                                    </label>

                                    <input
                                      id="doc_rg"
                                      style={{visibility:"hidden",position:"absolute",left: -9999}}
                                      type="file"
                                      name="rg"
                                    />
                                  </div>
                                ) : null
                              }

                              <p style={this.styles.titleDoc}>RG</p>
                              {/* todo */}
                              {  
                                  this.state.detailsData.imagesDoc.rg != "" ? (
                              <a
                                onClick={this.openWindow.bind(this, this.state.detailsData.imagesDoc.rg, "Imagem do RG")}
                                target="_blank">
                                
                                {
                                    
                                  this.state.detailsData.imagesDoc.rg.substr(this.state.detailsData.imagesDoc.rg.length - 3, this.state.detailsData.imagesDoc.rg.length).toLowerCase() == "pdf" ? (
                                  <span>
                                    &nbsp;&nbsp;&nbsp;&nbsp;
                                    <i
                                      className="far fa-file-pdf fa-6x"
                                      style={{...this.styles.docPdf, backgroundColor: this.state.colorBackImg}}
                                    >&nbsp;</i>
                                  </span>
                                  ) : (
                                <img
                                  style={this.styles.doc}
                                  src={urlBase.loopBack + "attachments/docs/download/" + this.state.detailsData.imagesDoc.rg}
                                  alt="Imagem do RG"
                                />
                                  )
                                }
                              </a>
                                ) : (<div style={{marginTop: 25}}>Sem imagem <br/>cadastrada</div>)
                              }
                            </div>
                          </Grid>
{/* ################### Imagem RG (verso) ################### */}
                          <Grid item xs={12} sm={6} md={4} lg={4} style={{textAlign: "center"}}>
                            <div
                              style={{backgroundColor: this.state.colorBackImg, paddingBottom: 10, borderRadius:3}}
                            >
                              {
                                this.state.toggleChecked == true ? (
                                  <div>
                                    <label htmlFor="doc_rg2" style={{cursor:"pointer"}}>
                                      <i style={this.styles.penEdit} className="fas fa-pen">{""}</i>
                                    </label>

                                    <input
                                      id="doc_rg2"
                                      style={{visibility:"hidden",position:"absolute",left: -9999}}
                                      type="file"
                                      name="rg2"
                                      onChange={this.fileToBase64.bind(this, "rg2")}
                                    />
                                  </div>
                                ) : null
                              }

                              <p style={this.styles.titleDoc}>RG (Verso)</p>
                              {/* todo */}
                              {
                                  this.state.detailsData.imagesDoc.rg2 !=""  ? (
                              <a
                                onClick={this.openWindow.bind(this, this.state.detailsData.imagesDoc.rg2, "Imagem do RG")}
                                target="_blank">
                                {
                                  this.state.detailsData.imagesDoc.rg2.substr(this.state.detailsData.imagesDoc.rg2.length - 3, this.state.detailsData.imagesDoc.rg2.length).toLowerCase() == "pdf" ? (
                                  <span>
                                    &nbsp;&nbsp;&nbsp;&nbsp;
                                    <i
                                      className="far fa-file-pdf fa-6x"
                                      style={{...this.styles.docPdf, backgroundColor: this.state.colorBackImg}}
                                    >&nbsp;</i>
                                  </span>
                                  ) : (
                                <img
                                  style={this.styles.doc}
                                  src={urlBase.loopBack + "attachments/docs/download/" + this.state.detailsData.imagesDoc.rg2}
                                  alt="Imagem verso do RG"
                                />
                                  )
                                }
                              </a>
                                ) : (<div style={{marginTop: 25}}>Sem imagem <br/>cadastrada</div>)
                              }
                            </div>
                          </Grid>
{/* ################### Imagem CPF ################### */}
                          <Grid item xs={12} sm={6} md={4} lg={4} style={{textAlign: "center"}}>
                            <div
                              style={{backgroundColor: this.state.colorBackImg, paddingBottom: 10, borderRadius:3}}
                            >
                              {
                                this.state.toggleChecked == true ? (
                              <div>
                                <label htmlFor="doc_cpf" style={{cursor:"pointer"}}>
                                  <i style={this.styles.penEdit} className="fas fa-pen">{""}</i>
                                </label>

                                <input
                                  id="doc_cpf"
                                  style={{visibility:"hidden",position:"absolute",left: -9999}}
                                  type="file"
                                  name="cpf"
                                  onChange={this.fileToBase64.bind(this, "cpf")}
                                />
                              </div>
                                ) : null
                              }

                              <p style={this.styles.titleDoc}>CPF</p>
                              {
                                this.state.detailsData.imagesDoc.cpf !="" ? (
                              <a
                                onClick={this.openWindow.bind(this, this.state.detailsData.imagesDoc.cpf, "Imagem do CPF")}
                                target="_blank">
                                {
                                  this.state.detailsData.imagesDoc.cpf.substr(this.state.detailsData.imagesDoc.cpf.length - 3, this.state.detailsData.imagesDoc.cpf.length).toLowerCase() == "pdf" ? (
                                <i
                                  className="far fa-file-pdf fa-6x"
                                  style={{...this.styles.docPdf, backgroundColor: this.state.colorBackImg}}
                                >&nbsp;</i>
                                  ) : (
                                <img
                                  style={this.styles.doc}
                                  src={urlBase.loopBack + "attachments/docs/download/" + this.state.detailsData.imagesDoc.cpf}
                                  alt="Imagem do CPF"
                                />
                                  )
                                }
                              </a>
                                ) : (<div style={{marginTop: 25}}>Sem imagem <br/>cadastrada</div>)
                              }
                            </div>
                          </Grid>
{/* ################### Imagem Comp. de  Residência ################### */}
                          <Grid item xs={12} sm={6} md={4} lg={4} style={{textAlign: "center"}}>
                            <div
                              style={{backgroundColor: this.state.colorBackImg, paddingBottom: 10, borderRadius:3}}
                            >
                              {
                                this.state.toggleChecked == true ? (
                              <div>
                                <label htmlFor="doc_address" style={{cursor:"pointer"}}>
                                  <i style={this.styles.penEdit} className="fas fa-pen">{""}</i>
                                </label>

                                <input
                                  id="doc_address"
                                  style={{visibility:"hidden",position:"absolute",left: -9999}}
                                  type="file"
                                  name="address"
                                  onChange={this.fileToBase64.bind(this, "address")}
                                />
                              </div>
                                ) : ("")
                              }

                              <p style={this.styles.titleDoc}>Comp. de Residência</p>
                              {
                                this.state.detailsData.imagesDoc.resid !="" ? (
                              <a
                                onClick={this.openWindow.bind(this, this.state.detailsData.imagesDoc.resid, "Comp. de Residência")}
                                target="_blank">
                                {
                                  this.state.detailsData.imagesDoc.resid.substr(this.state.detailsData.imagesDoc.resid.length - 3, this.state.detailsData.imagesDoc.resid.length).toLowerCase() == "pdf" ? (
                                <i
                                  className="far fa-file-pdf fa-6x"
                                  style={{...this.styles.docPdf, backgroundColor: this.state.colorBackImg}}
                                >&nbsp;</i>
                                  ) : (
                                <img
                                  style={this.styles.doc}
                                  src={urlBase.loopBack + "attachments/docs/download/" + this.state.detailsData.imagesDoc.resid}
                                  alt="Imagem do RG"
                                />
                                  )
                                }
                              </a>
                                ) : (<div style={{marginTop: 25}}>Sem imagem <br/>cadastrada</div>)
                              }
                            </div>
                          </Grid>
{/* ################### Imagem Cartão de Crédito ################### */}
                          <Grid item xs={12} sm={6} md={4} lg={4} style={{textAlign: "center"}}>
                            <div
                              style={{backgroundColor: this.state.colorBackImg, paddingBottom: 10, borderRadius:3}}
                            >
                              {
                                this.state.toggleChecked == true ? (
                              <div>
                                <label htmlFor="doc_credtFrontal" style={{cursor:"pointer"}}>
                                  <i style={this.styles.penEdit} className="fas fa-pen">{""}</i>
                                </label>

                                <input
                                  id="doc_credtFrontal"
                                  style={{visibility:"hidden",position:"absolute",left: -9999}}
                                  type="file"
                                  name="credtFrontal"
                                  onChange={this.fileToBase64.bind(this, "credtFrontal")}
                                />
                              </div>
                                ) : null
                              }

                              <p style={this.styles.titleDoc}>Cartão de Crédito</p>
                              {
                                this.state.detailsData.imagesDoc.credtFrontal !='' ? (
                              <a
                                onClick={this.openWindow.bind(this, this.state.detailsData.imagesDoc.credtFrontal, 'Cartão de Crédito')}
                                target="_blank">
                                {
                                  this.state.detailsData.imagesDoc.credtFrontal.substr(this.state.detailsData.imagesDoc.credtFrontal.length - 3, this.state.detailsData.imagesDoc.credtFrontal.length).toLowerCase() == 'pdf' ? (
                                <i
                                  className="far fa-file-pdf fa-6x"
                                  style={{...this.styles.docPdf, backgroundColor: this.state.colorBackImg}}
                                >&nbsp;</i>
                                  ) : (
                                <img
                                  style={this.styles.doc}
                                  src={urlBase.loopBack + 'attachments/docs/download/' + this.state.detailsData.imagesDoc.credtFrontal}
                                  alt="Cartão de Crédito"
                                />
                                  )
                                }
                              </a>
                                ) : (<div style={{marginTop: 25}}>Sem imagem <br/>cadastrada</div>)
                              }
                            </div>
                          </Grid>
{/* ################### Imagem Contrato Físico ################### */}
                          <Grid item xs={12} sm={6} md={4} lg={4} style={{textAlign: 'center'}}>
                            <div
                              style={{backgroundColor: this.state.colorBackImg, paddingBottom: 10, borderRadius:3}}
                            >
                              {
                                this.state.toggleChecked == true ? (
                              <div>
                                <label htmlFor="doc_physicalContract" style={{cursor:'pointer'}}>
                                  <i style={this.styles.penEdit} className="fas fa-pen">{''}</i>
                                </label>

                                <input
                                  id="doc_physicalContract"
                                  style={{visibility:"hidden",position:'absolute',left: -9999}}
                                  type="file"
                                  name="physicalContract"
                                  onChange={this.fileToBase64.bind(this, 'physicalContract')}
                                />
                              </div>
                                ) : ('')
                              }

                              <p style={this.styles.titleDoc}>Contrato Físico</p>
                              {
                                this.state.detailsData.imagesDoc.physicalContract !='' ? (
                              <a
                                onClick={this.openWindow.bind(this, this.state.detailsData.imagesDoc.physicalContract, 'Contrato Físico')}
                                target="_blank">
                                {
                                  this.state.detailsData.imagesDoc.physicalContract.substr(this.state.detailsData.imagesDoc.physicalContract.length - 3, this.state.detailsData.imagesDoc.physicalContract.length).toLowerCase() == 'pdf' ? (
                                <i
                                  className="far fa-file-pdf fa-6x"
                                  style={{...this.styles.docPdf, backgroundColor: this.state.colorBackImg}}
                                >&nbsp;</i>
                                  ) : (
                                <img
                                  style={this.styles.doc}
                                  src={urlBase.loopBack + 'attachments/docs/download/' + this.state.detailsData.imagesDoc.physicalContract}
                                />
                                  )
                                }
                              </a>
                                ) : (<div style={{marginTop: 25}}>Sem imagem <br/>cadastrada</div>)
                              }
                            </div>
                          </Grid>
{/* ################### Imagem Aditivo ################### */}
                          <Grid item xs={12} sm={6} md={4} lg={4} style={{textAlign: 'center'}}>
                            <div
                              style={{backgroundColor: this.state.colorBackImg, paddingBottom: 10, borderRadius:3}}
                            >
                              {
                                this.state.toggleChecked == true ? (
                              <div>
                                <label htmlFor="doc_adtive" style={{cursor:'pointer'}}>
                                  <i style={this.styles.penEdit} className="fas fa-pen">{''}</i>
                                </label>

                                <input
                                  id="doc_adtive"
                                  style={{visibility:"hidden",position:'absolute',left: -9999}}
                                  type="file"
                                  name="adtive"
                                  onChange={this.fileToBase64.bind(this, 'adtive')}
                                />
                              </div>
                                ) : ('')
                              }

                              <p style={this.styles.titleDoc}>Aditivo</p>
                              {
                                this.state.detailsData.imagesDoc.adtive !='' ? (
                              <a
                                onClick={this.openWindow.bind(this, this.state.detailsData.imagesDoc.adtive, 'Aditivo')}
                                target="_blank">
                                {
                                  this.state.detailsData.imagesDoc.adtive.substr(this.state.detailsData.imagesDoc.adtive.length - 3, this.state.detailsData.imagesDoc.adtive.length).toLowerCase() == 'pdf' ? (
                                <i
                                  className="far fa-file-pdf fa-6x"
                                  style={{...this.styles.docPdf, backgroundColor: this.state.colorBackImg}}
                                >&nbsp;</i>
                                  ) : (
                                <img
                                  style={this.styles.doc}
                                  src={urlBase.loopBack + 'attachments/docs/download/' + this.state.detailsData.imagesDoc.adtive}
                                />
                                  )
                                }
                              </a>
                                ) : (<div style={{marginTop: 25}}>Sem imagem <br/>cadastrada</div>)
                              }
                            </div>
                          </Grid>
                    {/* ################### Imagem Declaração de Portabilidade ################### */}
    <Grid item xs={12} sm={6} md={4} lg={4} style={{textAlign: 'center'}}>
      <div
        style={{backgroundColor: this.state.colorBackImg, paddingBottom: 10, borderRadius:3}}
      >
        {
          this.state.toggleChecked == true ? (
        <div>
          <label htmlFor="doc_declarationPortability" style={{cursor:'pointer'}}>
            <i style={this.styles.penEdit} className="fas fa-pen">{''}</i>
          </label>

          <input
            id="doc_declarationPortability"
            style={{visibility:"hidden",position:'absolute',left: -9999}}
            type="file"
            name="declarationPortability"
            onChange={this.fileToBase64.bind(this, 'declarationPortability')}
          />
        </div>
          ) : null
        }

        <p style={this.styles.titleDoc}>Declaração de Portabilidade</p>
        {
          this.state.detailsData.imagesDoc.declarationPortability !='' ? (
        <a
          onClick={this.openWindow.bind(this, this.state.detailsData.imagesDoc.declarationPortability, 'Aditivo')}
          target="_blank">
          {
            this.state.detailsData.imagesDoc.declarationPortability.substr(this.state.detailsData.imagesDoc.declarationPortability.length - 3, this.state.detailsData.imagesDoc.declarationPortability.length).toLowerCase() == 'pdf' ? (
          <i
            className="far fa-file-pdf fa-6x"
            style={{...this.styles.docPdf, backgroundColor: this.state.colorBackImg}}
          >&nbsp;</i>
            ) : (
          <img
            style={this.styles.doc}
            src={urlBase.loopBack + 'attachments/docs/download/' + this.state.detailsData.imagesDoc.declarationPortability}
          />
            )
          }
        </a>
          ) : (<div style={{marginTop: 25}}>Sem imagem <br/>cadastrada</div>)
        }
      </div>
    </Grid>
{/* ################### Imagem Outro ################### */}
                          <Grid item xs={12} sm={6} md={4} lg={4} style={{textAlign: 'center'}}>
                            <div
                              style={{backgroundColor: this.state.colorBackImg, paddingBottom: 10, borderRadius:3}}
                            >
                              {
                                this.state.toggleChecked == true ? (
                              <div>
                                <label htmlFor="doc_others" style={{cursor:'pointer'}}>
                                  <i style={this.styles.penEdit} className="fas fa-pen">{''}</i>
                                </label>

                                <input
                                  id="doc_others"
                                  style={{visibility:"hidden",position:'absolute',left: -9999}}
                                  type="file"
                                  name="others"
                                  onChange={this.fileToBase64.bind(this, 'others')}
                                />
                              </div>
                                ) : ('')
                              }

                              <p style={this.styles.titleDoc}>Outro</p>
                              {
                                this.state.detailsData.imagesDoc.others !='' ? (
                              <a
                                onClick={this.openWindow.bind(this, this.state.detailsData.imagesDoc.others, 'Outro')}
                                target="_blank">
                                {
                                  this.state.detailsData.imagesDoc.others.substr(this.state.detailsData.imagesDoc.others.length - 3, this.state.detailsData.imagesDoc.others.length).toLowerCase() == 'pdf' ? (
                                <i
                                  className="far fa-file-pdf fa-6x"
                                  style={{...this.styles.docPdf, backgroundColor: this.state.colorBackImg}}
                                >&nbsp;</i>
                                  ) : (
                                <img
                                  style={this.styles.doc}
                                  src={urlBase.loopBack + 'attachments/docs/download/' + this.state.detailsData.imagesDoc.others}
                                />
                                  )
                                }
                              </a>
                                ) : (<div style={{marginTop: 25}}>Sem imagem <br/>cadastrada</div>)
                              }
                            </div>
                          </Grid>
                        </Grid>
                      </Grid>
                    </Grid>
                  </fieldset>

                  <fieldset style={this.styles.fieldset}>
                    <legend style={this.styles.legend}>
                      Titular
                    </legend>

                    <Grid container spacing={24}>
                      <Grid item style={this.styles.col} xs={12} sm={12} md={6} lg={6}>
                        <label style={this.styles.label} htmlFor="h_firstName">Nome</label>
                        <Input
                          id="h_firstName"
                          style={this.styles.input}
                          type="text"
                          disabled={true}
                          defaultValue={this.state.detailsData.holder.firstName + this.state.detailsData.holder.lastName}
                        />
                      </Grid>
                      <Grid item style={this.styles.col} xs={12} sm={12} md={6} lg={6}>
                        <label style={this.styles.label}  htmlFor="h_susNumber">Cartão SUS</label>
                        <Input
                          id="h_susNumber"
                          style={this.styles.input}
                          type="text"
                          disabled={true}
                          defaultValue={this.state.detailsData.holder.susNumber}
                        />
                      </Grid>
                      <Grid item style={this.styles.col} xs={12} sm={12} md={3} lg={3}>
                        <label style={this.styles.label} htmlFor="h_cpf">CPF</label>
                        <InputMask
                          id="h_cpf"
                          style={this.styles.input}
                          mask="999.999.999-99"
                          className="form-control"
                          type="tel"
                          disabled={true}
                          defaultValue={this.state.detailsData.holder.cpf}
                        />
                        <Alert id="alert_h_cpf">*Cpf inválido!</Alert>
                        <style>{`
                          #alert_h_cpf {
                            display: none;
                            font-size: 12px !important;
                            background-color: #FFFFFF !important;
                            color: #d51125 !important;
                            border-color: #FFFFFF;
                            padding-left: 0px !important;
                            padding-top: 3px !important;
                            margin-bottom: 0px !important;
                          }
                        `}</style>
                      </Grid>
                      <Grid item style={this.styles.col} xs={12} sm={12} md={3} lg={3}>
                        <label style={this.styles.label} htmlFor="h_dateOfBirth">Data de Nasc.</label>
                        <Input
                          id="h_dateOfBirth"
                          style={this.styles.input}
                          type="date"
                          disabled={true}
                          defaultValue={this.state.detailsData.holder.dateOfBirth}
                        />
                      </Grid>
                      <Grid item style={this.styles.col} xs={12} sm={12} md={3} lg={3}>
                        <label style={this.styles.label} htmlFor="h_maritalStatus">Estado Civil</label>
                        <Input
                          id="h_maritalStatus"
                          className="form-control"                          
                          defaultValue={this.state.detailsData.holder.maritalStatus}
                          disabled={true}
                        />

                      </Grid>
                      <Grid item style={this.styles.col} xs={12} sm={12} md={3} lg={3}>
                        <label style={this.styles.label} htmlFor="h_gender">Sexo</label>
                        <Input
                          id="h_gender"
                          className="form-control"
                          
                          defaultValue={this.state.detailsData.holder.gender === 1 ? "MASCULINO" : "FEMININO"}
                          disabled={true}

                        />

                      </Grid>
                      <Grid item style={this.styles.col} xs={12} sm={12} md={10} lg={10}>
                        <label style={this.styles.label} htmlFor="h_motherName">Nome da Mãe</label>
                        <Input
                          id="h_motherName"
                          style={this.styles.input}
                          type="text"
                          disabled={true}
                          defaultValue={this.state.detailsData.holder.motherName}

                        />
                      </Grid>
                      <Grid item style={this.styles.col} xs={12} sm={12} md={2} lg={2}>
                        <label style={this.styles.label} htmlFor="h_valuePlan">Valor</label>
                        <CurrencyFormat
                          id="h_valuePlan"
                          className="form-control"
                          style={this.styles.input}
                          type="tel"
                          thousandSeparator="."
                          prefix={'R$ '}
                          decimalScale={2}
                          decimalSeparator=","
                          disabled={true}
                          value={this.state.detailsData.holder.valuePlan}
                           />
                      </Grid>
                    </Grid>
                  </fieldset>

                  <fieldset style={this.styles.fieldset}>
                    <legend style={this.styles.legend}>
                      Dependentes
                    </legend>

                  {
                    this.state.detailsData.dependents.length == 0 ? (
                    <Grid container spacing={24}>
                      <Grid item xs={12} sm={12} md={12} lg={12}>
                        Não possui dependentes
                      </Grid>
                    </Grid>
                    ) : (
                      this.state.detailsData.dependents.map((item, index) =>
                    <Grid container spacing={24} key={index}>
                      <Grid item style={this.styles.col} xs={12} sm={12} md={6} lg={6}>
                        <label style={this.styles.label}>Nome</label>
                        <Input
                          id={index + '_firstName'}
                          style={this.styles.input}
                          type="text"
                          disabled={true}
                          defaultValue={item.firstName + item.lastName}

                        />
                      </Grid>
                      <Grid item style={this.styles.col} xs={12} sm={12} md={3} lg={3}>
                        <label style={this.styles.label}>CPF</label>
                        <InputMask
                          id={index + '_cpf'}
                          style={this.styles.input}
                          mask="999.999.999-99"
                          className="form-control"
                          type="tel"
                          disabled={true}
                          defaultValue={item.cpf}
                        />
                      </Grid>
                      <Grid item style={this.styles.col} xs={12} sm={12} md={3} lg={3}>
                        <label style={this.styles.label}>Data de Nasc.</label>
                        <Input
                          id={index + '_dateOfBirth'}
                          style={this.styles.input}
                          type="date"
                          disabled={true}
                          defaultValue={item.dateOfBirth}
                        />
                      </Grid>
                      <Grid item style={this.styles.col} xs={12} sm={12} md={6} lg={6}>
                        <label style={this.styles.label}>Nome da Mãe</label>
                        <Input
                          id={index + '_motherName'}
                          style={this.styles.input}
                          type="text"
                          disabled={true}
                          defaultValue={item.motherName}

                        />
                      </Grid>
                      <Grid item style={this.styles.col} xs={12} sm={12} md={2} lg={2}>
                        <label style={this.styles.label}>Perentesco</label>
                        <Input
                          id={index + '_parentage'}
                          className="form-control"
                          defaultValue={item.parentage}
                          disabled={true}
                        />

                      </Grid>
                      <Grid item style={this.styles.col} xs={12} sm={12} md={2} lg={2}>
                        <label style={this.styles.label}>Sexo</label>
                        <Input
                          id={index + '_gender'}
                          className="form-control"
                          defaultValue={item.gender === 1 ? "MASCULINO" : "FEMININO"}
                          disabled={true}
                        />

                      </Grid>
                      <Grid item style={this.styles.col} xs={12} sm={12} md={2} lg={2}>
                        <label style={this.styles.label}>Estado Civil</label>
                        <Input
                          id={index + '_maritalStatus'}
                          className="form-control"
                          defaultValue={item.maritalStatus}
                          disabled={true}

                        />

                      </Grid>
                      <Grid item style={this.styles.col} xs={12} sm={12} md={4} lg={4}>
                        <label style={this.styles.label}>Cartão SUS</label>
                        <Input
                          id={index + '_susNumber'}
                          style={this.styles.input}
                          type="text"
                          disabled={true}
                          defaultValue={item.susNumber}
                        />
                      </Grid>
                      <Grid item style={this.styles.col} xs={12} sm={12} md={2} lg={2}>
                        <label style={this.styles.label}>Valor</label>
                        <CurrencyFormat
                          id={index + '_valuePlan'}
                          className="form-control"
                          style={this.styles.input}
                          type="tel"
                          thousandSeparator="."
                          prefix={'R$ '}
                          decimalScale={2}
                          decimalSeparator=","
                          disabled={true}
                          value={item.valuePlan}
                        />
                      </Grid>

                      {
                        index + 1 < this.state.detailsData.dependents.length ? (
                      <div style={{width: '100%', margin: '15px 0px'}}>
                        <Divider
                          style={{width: '100%', backgroundColor: 'rgb(245, 170, 0)'}}
                        />
                      </div>
                        ) : ('')
                      }
                    </Grid>
                      )
                    )
                  }
                  </fieldset>

                  <fieldset style={this.styles.fieldset}>
                    <legend style={this.styles.legend}>
                      Info. Plano
                    </legend>

                    <Grid container spacing={24}>
                      <Grid item style={this.styles.col} xs={12} sm={12} md={4} lg={4}>
                        <label 
                            style={this.styles.label}
                            htmlFor="fm_nome_plano">
                              Nome
                        </label>
                        <Input style={this.styles.input} id="fm_nome_plano" type="text" disabled
                          defaultValue={this.state.detailsData.plan.name} />
                      </Grid>
                      <Grid item style={this.styles.col} xs={12} sm={12} md={3} lg={3}>
                        <label style={this.styles.label} htmlFor="fm_responsibility">Valor Total Mensal</label>
                        <Input
                          id="fm_responsibility"
                          style={this.styles.input}
                          type="text"
                          disabled={true}
                          defaultValue={this.state.detailsData.financialManager.responsibility}
                        />
                      </Grid>
                      <Grid item style={this.styles.col} xs={12} sm={12} md={3} lg={3}>
                        <label style={this.styles.label} htmlFor="fm_data_adesao">Data de Adesão</label>
                        <Input style={this.styles.input} id="fm_data_adesao" type="text" disabled
                          defaultValue={this.state.detailsData.financialManager.dateSignatureContract} />
                      </Grid>

                      <Grid item style={this.styles.col} xs={12} sm={12} md={2} lg={2}>
                        <label style={this.styles.label} htmlFor="fm_contractNumberS4">Cód. pagamento</label>
                        <Input style={this.styles.input} 
                          type="text" 
                          id="fm_contractNumberS4"
                          disabled={true}                     
                          defaultValue={this.state.detailsData.financialManager.contractNumberS4}
                      />
                      </Grid>
                         
                      {
                        this.state.showFirstPayment == true ? (
                      <Grid item style={this.styles.col} xs={12} sm={12} md={6} lg={6}>
                        <label style={this.styles.label}>Primeiro Faturamento</label>
                        <Grid container spacing={24}>
                          <Grid item style={this.styles.col} xs={12} sm={12} md={6} lg={6}>
                            <FormGroup row style={{marginRight: -8, marginLeft: -8}}>
                              <Label for="i_month" sm={2}>Mês:</Label>
                              <Col sm={10}>
                                <Input
                                  type="select"
                                  id="i_month"
                                  className="form-control"
                                  
                                  defaultValue={this.state.detailsData.holder.dateFirstPayment.substr(4,6)}
                                >
                                  <option value="01">01 - Jan</option>
                                  <option value="02">02 - Fev</option>
                                  <option value="03">03 - Mar</option>
                                  <option value="04">04 - Abr</option>
                                  <option value="05">05 - Mai</option>
                                  <option value="06">06 - Jun</option>
                                  <option value="07">07 - Jul</option>
                                  <option value="08">08 - Ago</option>
                                  <option value="09">09 - Set</option>
                                  <option value="10">10 - Out</option>
                                  <option value="11">11 - Nov</option>
                                  <option value="12">12 - Dez</option>
                                </Input>
                              </Col>
                            </FormGroup>
                          </Grid>
                          <Grid item style={this.styles.col} xs={12} sm={12} md={6} lg={6}>
                            <FormGroup row style={{marginRight: -8, marginLeft: -8}}>
                              <Label for="i_year" sm={2}>Ano:</Label>
                              <Col sm={10}>
                                <Input
                                  type="select"
                                  id="i_year"
                                  className="form-control"
                                  
                                  defaultValue={this.state.detailsData.holder.dateFirstPayment.substr(0,4)}
                                />
                              </Col>
                            </FormGroup>
                          </Grid>
                        </Grid>
                      </Grid>
                        ) : null
                      }

                    </Grid>
                  </fieldset>

                  <fieldset style={this.styles.fieldset}>
                    <legend style={this.styles.legend}>
                      Info. Corretora
                    </legend>

                    <Grid container spacing={24}>
                      <Grid item style={this.styles.col} xs={12} sm={12} md={12} lg={12}>
                        <label style={this.styles.label} htmlFor="id_corretora">Corretora</label>
                        <Input style={this.styles.input} id="id_corretora" type="text" disabled
                          defaultValue={this.state.detailsData.broker.user.name} />
                      </Grid>
                      <Grid item style={this.styles.col} xs={12} sm={12} md={8} lg={8}>
                        <label style={this.styles.label} htmlFor="id_vendedor">Vendedor</label>
                        <Input style={this.styles.input} id="id_vendedor" type="text" disabled
                          defaultValue={this.state.detailsData.salesman.user.name} />
                      </Grid>
                      <Grid item style={this.styles.col} xs={12} sm={12} md={4} lg={4}>
                        <label style={this.styles.label}  htmlFor="id_codigo">Código</label>
                        <Input style={this.styles.input} id="id_codigo" type="text" disabled
                          defaultValue={this.state.detailsData.salesman.codeS4} />
                      </Grid>
                    </Grid>
                  </fieldset>


                  <fieldset style={this.styles.fieldset}>
                    <legend style={this.styles.legend}>
                      Dados Financeiros
                    </legend>

                    <Grid container spacing={24}>
                      <Grid item style={this.styles.col} xs={12} sm={12} md={12} lg={12}>
                        Desconto em folha
                      </Grid>
                    </Grid>
                  </fieldset>



                  {/* Para as pendências */}
                  {
                    this.state.detailsData.sales.pendencyId ? (
                  <fieldset style={this.styles.fieldset}>
                      <legend style={this.styles.legend}>
                        Pendência
                      </legend>
  
                      <Grid container spacing={24}>
                        <Grid item style={this.styles.col} xs={12} sm={12} md={1} lg={1}>
                          &nbsp;
                        </Grid>
                        <Grid item style={this.styles.col} xs={12} sm={12} md={10} lg={10}>  
                              <Input
                                style={{ margin: "10px auto 0 auto" }}
                                type="select"
                                className="form-control"
                                disabled
                                // Convertemos o ID da proposta explicitamente para String
                                value={
                                  this.state.detailsData && this.state.detailsData.sales && this.state.detailsData.sales.pendencyId 
                                    ? String(this.state.detailsData.sales.pendencyId) 
                                    : ""
                                }
                              >
                                <option value="">Selecione a pendência...</option>
                                
                                {(this.state.listaPendencias || []).map((item, index) => (
                                  // IMPORTANTE: Convertemos o valor da option explicitamente para String também
                                  <option key={index} value={String(item.id)}>
                                    {item.code + " - " + item.name}
                                  </option>
                                ))}
                              </Input>
                        </Grid>
                        <Grid item style={this.styles.col} xs={12} sm={12} md={1} lg={1}>
                          &nbsp;
                        </Grid>
                      </Grid>
                    </fieldset>  
                    ) : null
                  }    
                  {/* Para o campo de observação */}
                        {
                         this.state.detailsData.sales.observation 
                          ? (                  
                  <fieldset style={this.styles.fieldset}>
                    <label htmlFor="sl_observation" style={this.styles.legend}>
                      Observações
                    </label>

                    <Grid container spacing={24}>

                      <Grid item style={this.styles.col} xs={12} sm={12} md={12} lg={12}>
                        <Input
                          id="sl_observation"
                          style={{width:"100%", height: 100}}
                          type="textarea"
                          disabled
                          defaultValue={this.state.detailsData.sales.observation}
                        />
                      </Grid>

                    </Grid>
                  </fieldset>
                    ) : null
                  }
                  {/* Rodapé do Modal Principal com as Ações */}
                  <div className="modal-footer">
                    <button 
                      type="button" 
                      onClick={this.handleModalClose.bind(this)}
                      style={{ 
                      ...Styles.buttonCancel, 
                      backgroundColor: Colors.textLight, // Usando cinza para cancelar
                      textTransform: 'none' 
                      }}                   
                    >
                      Fechar
                    </button>  
                    {
                      this.state.detailsData.sales.status != "CANCELADO" && 
                      this.state.detailsData.sales.status != "ATIVO"   ? (                     
                    <button 
                      type="button" 
                      onClick={this.abrirModalCancelamento}
                        style={{
                        ...Styles.buttonSuccess,
                        fontWeight: 'bold',
                        textTransform: 'none'
                        }}                       
                    >
                      Cancelar
                    </button>
                      ) : null
                    }                                      
                    {
                      this.state.detailsData.sales.status != "ATIVO" && 
                      this.state.detailsData.sales.status != "CANCELADO" ? ( 
                    <button 
                      type="button" 
                        onClick={this.handleBtnRegistrarPendencia.bind(this)}
                        style={{
                        ...Styles.buttonSuccess,
                        fontWeight: 'bold',
                        textTransform: 'none'
                        }}                        
                    >
                      Registrar Pendência
                    </button>
                      ) : null
                    }
                    {
                      this.state.detailsData.sales.status != "PENDENTE" && 
                      this.state.detailsData.sales.status != "ATIVO" &&
                      this.state.detailsData.sales.status != "CANCELADO" ?  (                     
                    <button 
                      type="button" 
                      onClick={this.abrirModal}
                        style={{
                        ...Styles.buttonSuccess,
                        fontWeight: 'bold',
                        textTransform: 'none'
                        }}                       
                    >
                      Ativar Proposta
                    </button>
                      ) : null
                    }                    
                  </div>



                  {/* Para os cancelamentos */
                    this.state.detailsData.sales.status == "CANCELADO" ? (
                    <fieldset style={this.styles.fieldset}>
                      <legend style={this.styles.legend}>
                        Cancelamento
                      </legend>
  
                      <Grid container spacing={24}>
                        <Grid item style={this.styles.col} xs={12} sm={12} md={1} lg={1}>
                          &nbsp;
                        </Grid>
                        <Grid item style={this.styles.col} xs={12} sm={12} md={10} lg={10}>  
                          <Input
                            style={{width: "46%", margin: "10px auto 0 auto"}}
                            type="select"
                            className="form-control"
                            disabled
                            defaultValue={this.state.detailsData.sales.cancellationId}
                          >
                            {this.state.listaCancelados && this.state.listaCancelados.map((item, index) =>
                              <option key={index} value={item.id}>{item.code + " - " + item.name}</option>
                            )}
                          </Input>
                        </Grid>
                        <Grid item style={this.styles.col} xs={12} sm={12} md={1} lg={1}>
                          &nbsp;
                        </Grid>
                      </Grid>
                    </fieldset>
                    ) : null
                  }


                </div>
                /* fim da div */
                  )))}
              </div>
                  {/* ======================================================== */}
                  {/* MODAL DE PENDÊNCIAS (SELEÇÃO ÚNICA - COMPATÍVEL COM ES5) */}
                  {/* ======================================================== */}
                  {this.state.modalPendenciaOpen && (
                    <div style={{
                      position: 'fixed', top: 0, left: 0, width: '100%', height: '100%',
                      backgroundColor: 'rgba(0,0,0,0.5)', zIndex: 9999, display: 'flex',
                      justifyContent: 'center', alignItems: 'center'
                    }}>
                      <div style={{
                        background: '#fff', width: '600px', borderRadius: '4px',
                        padding: '20px', boxShadow: '0 4px 12px rgba(0,0,0,0.3)',
                        maxHeight: '80vh', overflowY: 'auto'
                      }}>
                        
                        {/* Cabeçalho do Modal */}
                        <div style={{ display: 'flex', justifyContent: 'space-between', borderBottom: '1px solid #eee', paddingBottom: '10px', marginBottom: '15px' }}>
                          <h4 style={{ margin: 0, fontWeight: 'bold', color: '#333', fontSize: '18px' }}>Selecione a Pendência</h4>
                          <button 
                            type="button" 
                            className="close" 
                            style={{ border: 'none', background: 'transparent', fontSize: '22px', cursor: 'pointer' }}
                            onClick={function() { this.setState({ modalPendenciaOpen: false }); }.bind(this)}
                          >
                            &times;
                          </button>
                        </div>

                        {/* Filtro de Pesquisa */}
                        <div className="form-group" style={{ marginBottom: '15px' }}>
                          <input 
                            type="text" 
                            className="form-control" 
                            placeholder="Pesquisar pendência por código ou descrição..."
                            value={this.state.buscaPendencia}
                            onChange={function(e) { this.setState({ buscaPendencia: e.target.value }); }.bind(this)}
                          />
                        </div>

                        {/* Tabela de Listagem */}
                        <div className="table-responsive" style={{ maxHeight: '250px', overflowY: 'auto' }}>
                          <table className="table table-striped table-hover table-bordered" style={{ marginBottom: 0 }}>
                            <thead>
                              <tr style={{ backgroundColor: '#f5f5f5' }}>
                                <th style={{ width: '50px', textAlign: 'center' }}>Selecione</th>
                                <th style={{ width: '90px', textAlign: 'center' }}>Código</th>
                                <th>Descrição</th>
                              </tr>
                            </thead>
                            <tbody>
                              {this.state.listaPendencias
                                .filter(function(item) {
                                  let busca = (this.state.buscaPendencia || '').toLowerCase();
                                  let codigo = (item.code || '').toLowerCase();
                                  let nome = (item.name || '').toLowerCase();
                                  return codigo.indexOf(busca) !== -1 || nome.indexOf(busca) !== -1;
                                }.bind(this))
                                .map(function(pendencia, index) {
                                  // AJUSTADO: Agora lê corretamente de pendencia.id
                                  let isSelected = this.state.pendenciaSelecionada === pendencia.id;

                                  return (
                                    <tr 
                                      // AJUSTADO: Chave única usando o id correto
                                      key={'pendencia_row_' + pendencia.id + '_' + index} 
                                      style={{ cursor: 'pointer', backgroundColor: isSelected ? '#fffcf0' : 'transparent' }} 
                                      // AJUSTADO: Passa o id correto para a função de seleção
                                      onClick={function() { this.selecionarPendencia(pendencia.id); }.bind(this)}
                                    >
                                      <td style={{ textAlign: 'center' }}>
                                        <input 
                                          name="grupo_selecao_pendencia"
                                          type="radio" 
                                          checked={isSelected}
                                          // AJUSTADO: Valor do radio amarrado ao id correto
                                          value={pendencia.id}
                                          onChange={function() {}.bind(this)} 
                                        />
                                      </td>
                                      <td style={{ fontWeight: 'bold', textAlign: 'center', color: '#555' }}>
                                        {pendencia.code}
                                      </td>
                                      <td>{pendencia.name}</td>
                                    </tr>
                                  );
                                }.bind(this))}

                              {/* Alerta de busca vazia */}
                              {this.state.listaPendencias.filter(function(item) {
                                let busca = (this.state.buscaPendencia || '').toLowerCase();
                                return (item.code || '').toLowerCase().indexOf(busca) !== -1 || (item.name || '').toLowerCase().indexOf(busca) !== -1;
                              }.bind(this)).length === 0 ? (
                                <tr>
                                  <td colSpan="3" style={{ textAlign: 'center', color: '#999', padding: '15px' }}>
                                    Nenhuma pendência encontrada para o termo digitado.
                                  </td>
                                </tr>
                              ) : null}
                            </tbody>
                          </table>
                        </div>
                          {/* ================================================================= */}
                          {/* NOVO CAMPO: OBSERVAÇÃO DA PENDÊNCIA                             */}
                          {/* ================================================================= */}
                          <div className="form-group" style={{ marginTop: '20px', marginBottom: '10px' }}>
                            <label style={{ fontWeight: 'bold', color: '#333', marginBottom: '5px' }}>
                              Observações / Detalhes da Pendência:
                            </label>
                            <textarea
                              className="form-control"
                              rows="3"
                              placeholder="Digite aqui as observações ou justificativas específicas sobre essa pendência..."
                              value={this.state.observation || ''}
                              onChange={function(e) { this.setState({ observation: e.target.value }); }.bind(this)}
                              style={{ resize: 'vertical' }}
                            />
                          </div>
                        {/* Rodapé */}
                        <div style={{ borderTop: '1px solid #eee', paddingTop: '15px', marginTop: '15px', textAlign: 'right' }}>
                              <button 
                                type="button" 
                                className="btn btn-default" 
                                style={{ marginRight: '10px' }}
                                onClick={function() { this.setState({ modalPendenciaOpen: false }); }.bind(this)}
                              >
                                Cancelar
                              </button>
                              <button 
                                type="button" 
                                className="btn btn-primary"
                                // O botão ficará desativado se NÃO houver pendência selecionada
                                disabled={!this.state.pendenciaSelecionada}
                                onClick={function() { this.salvarPendencias(); }.bind(this)}
                              >
                                Confirmar e Enviar E-mail
                              </button>
                        </div>

                      </div>
                    </div>
                  )}    
                  {/* ======================================================== */}
                  {/* MODAL DE EFETICAÇÃO DA PROPOSTA                          */}
                  {/* ======================================================== */}  
                  {/* Janela Modal Condicional */}
                  {this.state.showModalEfetivar && (
                    <div className="modal-backdrop" style={this.styles.backdrop}>
                      <div className="modal-box" style={this.styles.modalBox}>
                        <h3>Efetivação da Proposta</h3>
                        <p>Informe a data do primeiro pagamento para continuar:</p>
                        
                        <div className="form-group" style={{ marginBottom: '15px' }}>
                          <input 
                            type="text" 
                            placeholder="MM/AAAA"
                            maxLength="7"
                            className="form-control"
                            value={this.state.dataPrimeiroPagamento}
                            onChange={this.handleDataChange}
                            disabled={this.state.isEnviando}
                            style={{ fontSize: '16px', padding: '5px', width: '100px', textAlign: 'center' }}
                          />
                          {this.state.erroValidacao && (
                            <div style={{ color: 'red', marginTop: '5px', fontSize: '13px' }}>
                              {this.state.erroValidacao}
                            </div>
                          )}
                        </div>

                        {/* Barra de Progresso / Loading */}
                        {this.state.isEnviando && (
                          <div className="progress-container" style={this.styles.progressContainer}>
                            <div className="progress-bar-loading" style={this.styles.progressBarAnimated}></div>
                            <small>Processando efetivação, por favor aguarde...</small>
                          </div>
                        )}

                        {/* Botões de Ação */}
                        <div className="modal-buttons" style={{ marginTop: '20px', textAlign: 'right' }}>
                          <button 
                            type="button" 
                            className="btn btn-default" 
                            onClick={this.fecharModal}
                            disabled={this.state.isEnviando}
                            style={{ marginRight: '10px' }}
                          >
                            Cancelar
                          </button>
                          <button 
                            type="button" 
                            className="btn btn-primary" 
                            onClick={this.confirmarEfetivacao}
                            disabled={this.state.isEnviando}
                          >
                            {this.state.isEnviando ? 'Enviando...' : 'Confirmar'}
                          </button>
                        </div>
                      </div>
                    </div>
                  )}    
                  {/* ======================================================== */}
                  {/* MODAL DE CANCELAMENTO DA PROPOSTA                          */}
                  {/* ======================================================== */}  
                  {/* Janela Modal Condicional */}
                  {this.state.showModalCancelamento && (
                    <div className="modal-backdrop" style={this.styles.backdrop}>
                      <div className="modal-box" style={this.styles.modalBox}>
                        <h3>Cancelar Proposta</h3>
                        <p>Informe o motivo do cancelamento:</p>
                        
                        <div className="form-group" style={{ marginBottom: '15px' }}>

                          <Grid item style={{ textAlign: 'center' }} xs={12} sm={12} md={12} lg={12}>
                            <div style={{ textAlign: 'center' }}>
                              <label style={this.styles.label}>
                                Escolha um cancelamento
                              </label>

                              <Input
                                type="select"
                                value={this.state.selectedCancellationId}
                                onChange={(e) =>
                                  this.setState({
                                    selectedCancellationId: e.target.value
                                  })
                                }
                              >
                                <option value="">
                                  Selecione um motivo
                                </option>

                                {(this.state.listaCancelados || []).map((item, index) => (
                                  <option key={index} value={item.id}>
                                    {item.code + ' - ' + item.name}
                                  </option>
                                ))}
                              </Input>

                            </div>
                          </Grid>

                        </div>

                        {/* Barra de Progresso / Loading */}
                        {this.state.isEnviando && (
                          <div className="progress-container" style={this.styles.progressContainer}>
                            <div className="progress-bar-loading" style={this.styles.progressBarAnimated}></div>
                            <small>Processando cancelamento, por favor aguarde...</small>
                          </div>
                        )}

                        {/* Botões de Ação */}
                        <div className="modal-buttons" style={{ marginTop: '20px', textAlign: 'right' }}>
                          <button 
                            type="button" 
                            className="btn btn-default" 
                            onClick={this.fecharModalCancelamento}
                            disabled={this.state.isEnviando}
                            style={{ marginRight: '10px' }}
                          >
                            Cancelar
                          </button>
                          <button 
                            type="button" 
                            className="btn btn-primary" 
                            onClick={this.confirmarCancelamento}
                            disabled={this.state.isEnviando}
                          >
                            {this.state.isEnviando ? 'Cancelando...' : 'Confirmar'}
                          </button>
                        </div>
                      </div>
                    </div>
                  )}                                                  
            </Dialog>            
        </div>

      
      </MuiThemeProvider>
    );
  }
}

export default Averbacao;


/** WEBPACK FOOTER **
 ** ./src/components/Panel/Form/Averbacao.js
 **/